import styled from "styled-components";
import {
  BADI_COLORS,
  mediaquery,
  SHADOWS,
  unitizedPx,
} from "@badi/badi-components";

export const ImageWrapper = styled.div`
  position: relative;
  margin: 30px auto 8px auto;
  text-align: center;
  max-width: 100%;
`;

export const ActionsWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${BADI_COLORS.NEUTRAL.NEUTRAL_00};
  padding: ${unitizedPx(3)};
  box-shadow: ${SHADOWS.SHADOW_01};
  border-bottom-left-radius: ${unitizedPx(0.5)};
  border-bottom-right-radius: ${unitizedPx(0.5)};

  ${mediaquery.md`
    padding-left: 40%;
  `}
`;

export const ContentWrapper = styled.div`
  position: relative;
  overflow: scroll;
  height: calc(100% - ${unitizedPx(6)});

  ${mediaquery.md`
    padding: 0 40px;
    height: calc(100% - ${unitizedPx(12)});
  `}
`;

export const Root = styled.div`
  height: calc(100vh - ${unitizedPx(10)});
  display: flex;
  flex-direction: column;
`;

export const Anchor = styled.a`
  display: inline-block;
  color: inherit;
  text-decoration: underline;
`;

export const Reasons = styled.div`
  position: relative;
`;
